export const Colors = {
  primary: '#4CAF50',
  primaryDark: '#388E3C',
  primaryLight: '#C8E6C9',
  secondary: '#4A4A4A',
  secondaryLight: '#757575',
  background: '#F5F5F5',
  white: '#FFFFFF',
  black: '#000000',
  error: '#F44336',
  success: '#4CAF50',
  warning: '#FF9800',
  info: '#2196F3',
  border: '#E0E0E0',
  textPrimary: '#212121',
  textSecondary: '#757575',
  cardBackground: '#FFFFFF',
};

export const StatusColors = {
  new: '#4CAF50',
  contacted: '#2196F3',
  not_interested: '#9E9E9E',
  follow_up: '#9C27B0',
  leads: '#00C853',
  file: '#FF9800',
  unset: '#607D8B',  // Blue-gray for unset/no status
  no_status: '#607D8B',  // Blue-gray for no status
};

export const StatusLabels = {
  new: 'New',
  contacted: 'Contacted',
  not_interested: 'Not Interested',
  follow_up: 'Follow Up',
  leads: 'Lead',
  file: 'File',
  unset: 'No Status',
  no_status: 'No Status',
};

// Call Outcome colors
export const OutcomeColors = {
  connected: '#4CAF50',
  not_connecting: '#9E9E9E',
  no_answer: '#F44336',
  busy: '#FF9800',
  wrong_number: '#E91E63',
  voicemail: '#9C27B0',
};

export const OutcomeLabels = {
  connected: 'Connected',
  not_connecting: 'Not Connecting',
  no_answer: 'No Answer',
  busy: 'Busy',
  wrong_number: 'Wrong Number',
  voicemail: 'Voicemail',
};
